import { useEffect, useRef, useState } from "react";
import dynamic from "next/dynamic";
import Image from "next/image";

import { MenuItems } from "src/packages/lagaat-domain";
import keepTabWithin from "../../lib/keepTabWithin";

import grillerSrc from "../../../public/griller.svg";

const MobileTransition = dynamic(() => import("./MobileTransition"));

type Styled = {
  className?: string;
};

const closedButtonStyle = "relative z-30";

const openButtonStyle = "fixed z-30 top-8 right-5 sm:right-6 md:right-8";

const MobileMenu = ({ className, items }: { items: MenuItems } & Styled) => {
  const [open, setOpen] = useState(false);
  const [clickedOnce, setClickedOnce] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const close = () => {
    setOpen(false);
    buttonRef.current?.focus({ preventScroll: true });
  };

  const toggle = () => {
    setClickedOnce(true);
    setOpen(!open);
  };

  useEffect(() => {
    if (!open) {
      return;
    }
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        close();
      }
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [open]);

  return (
    <div className={`relative z-20 ${className ?? ""}`}>
      <div onKeyDown={open ? keepTabWithin : undefined}>
        <button
          ref={buttonRef}
          type="button"
          aria-expanded={open}
          className={open ? openButtonStyle : closedButtonStyle}
          onClick={toggle}
        >
          {!open && (
            <Image src={grillerSrc} width={28} height={28} alt="griller" />
          )}
          {open && (
            <Image
              src="/close.svg"
              width={28}
              height={28}
              alt="griller"
              priority={true}
            />
          )}
        </button>
        {clickedOnce && (
          <MobileTransition open={open} items={items} close={close} />
        )}
      </div>
    </div>
  );
};

export default MobileMenu;
